<template>
  <div class="animated fadeIn">
    <div class="app-default-heading clearfix">
      <h1 class="d-inline-block display-4 text-left">
        <span v-if="text">{{ this.text }}</span>
        <slot v-else></slot>
      </h1>
      <div class="d-inline-block float-right">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DefaultHeading",
    props: ["text"]
  }
</script>
